import React, { useEffect, useRef, useState } from "react"
import config from "../../../config";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import SearchMenu from "./SearchMenu";
import OutsideClick from "../../common/OutsideClick"
import { debouncedSuggestedSearchesOld } from "../../actionCreators/boostCommerceAC"
import { useDispatch } from "react-redux"
import { isSearchUrl } from "../../common/utils"

const SearchBar = React.memo((props) => {
    const [searchValue, setSearchValue] = useState('');
    const [inputFocused, setInputFocused] = useState(false);
    const { mobile, top_promo_banner_not_visible, closeMobileSearch } = props;
    const dispatch = useDispatch();
    const searchBarRef = useRef();

    useEffect(() => {
        if (isSearchUrl()) {
            const urlParams = new URLSearchParams(window.location.search);
            const q = urlParams.get('q');
            setSearchValue(q);
        }
    }, [])

    useEffect(() => {
        let isApiSubscribed = true;
        dispatch(debouncedSuggestedSearchesOld(isApiSubscribed, searchValue, () => {}));
        return () => {
            isApiSubscribed = false;
        };
    }, [searchValue])

    const handleOutsideClick = () => {
        if (mobile) {
            closeMobileSearch();
        }
        setInputFocused(false);
    }

    return (
        <OutsideClick callbackAction={handleOutsideClick} customClass="search-bar-old">
            <Form inline action={`${config.host_rebag_shop}/search`} ref={searchBarRef}>
                <InputGroup>
                    <InputGroup.Prepend>
                        <span className="icon-search"/>
                    </InputGroup.Prepend>
                    <FormControl
                        placeholder='Try searching "Louis Vuitton" or "Black Tote"'
                        aria-label="Search"
                        name="q"
                        autoFocus={!!mobile}
                        autoComplete="off"
                        value={searchValue || ""}
                        onChange={(e) => setSearchValue(e.target.value)}
                        onFocus={() => setInputFocused(true)}
                    />
                </InputGroup>
            </Form>
            <SearchMenu
                mobile={mobile}
                inputFocused={inputFocused}
                top_promo_banner_not_visible={top_promo_banner_not_visible}
                searchBarRef={searchBarRef}
                searchValue={searchValue}
            />
        </OutsideClick>
    )
})

export default SearchBar;